export const headers: string[] = [
	'Property Name',
	'Score',
	'Score Change',
	'Pages',
	'Issues',
	'Last Crawl',
	'Last Scan'
];
export const CSV_DATE_FORMAT = 'YYYY-MM-DD HH:mm';
